@if ((isVisible$ | async) && (hasNpsFeature$ | async)) {
  <div id="feedback-control">
    @if (!popupDismissed) {
      <feedback-popup (onDismiss)="dismissPopup()"
      (onShowModal)="showModalFromPopup()"></feedback-popup>
    }
    @if (popupDismissed) {
      <feedback-sleeve [isActive]="isFeedbackModalVisible" (onShowModal)="showModalFromSleeve()"></feedback-sleeve>
    }
    @if (isFeedbackModalVisible) {
      <feedback-modal [starter]="currentStarter" (onClose)="closeModal()"></feedback-modal>
    }
  </div>
}
